module.exports = __webpack_public_path__ + "img/hand-ocean.3fed276d.jpeg";